// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"038abef6","227":"4aae75df"}[chunkId] + ".chunk.css";
};